module.exports = __webpack_public_path__ + "img/9791157230983.f6ff70a3.jpg";